module.exports = "/img/12.b7ded7.webp";